import { useTheme } from 'next-themes';
import { memo, useEffect, useMemo, useState } from 'react';
import { CardElement } from 'react-stripe-elements';

import { grey, greyDark, red, redDark } from '@air/colors';

import { CreditCardsIcons } from '~/components/Workspace/Checkout/PaymentFields/CreditCardsIcons';

export type PaymentFieldsProps = {
  disabled?: boolean;
};

export const PaymentFields = memo(({ disabled }: PaymentFieldsProps) => {
  const theme = useTheme();

  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const isDark = theme?.theme === 'dark';

  const fieldStyles = useMemo(
    () => ({
      base: {
        color: isDark ? greyDark.grey12.hex : grey.grey12.hex,
        '::placeholder': { color: isDark ? greyDark.grey8.hex : grey.grey8.hex },
      },
      invalid: {
        color: isDark ? redDark.red10.hex : red.red10.hex,
      },
    }),
    [isDark],
  );

  if (!isMounted) {
    return null;
  }

  return (
    <div className="flex w-full flex-col font-medium text-14 text-gray-10">
      <div className="mb-2 flex justify-between">
        <div className="text-12 text-gray-11">Credit card or debit card</div>
        <CreditCardsIcons className="mb-1.5" />
      </div>
      <CardElement style={fieldStyles} disabled={disabled} />
      <div className="mt-2.5 hidden whitespace-nowrap font-normal text-14 text-red-9">This value is invalid.</div>
    </div>
  );
});

PaymentFields.displayName = 'PaymentFields';
